"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = void 0;
var ContentType;
(function (ContentType) {
    ContentType["standard"] = "standard";
    ContentType["hardestQuestions"] = "hardestQuestions";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
//# sourceMappingURL=Content.js.map